var Menu = $.extend({/* Menu */}, BaseComponent, {

	componentSelector: 'menu-component',

	parameters: {
		trigger: '',
		menuSelector: ''
	},
	
	init: function() {
		// Binding actions events
		//$(/* class selector */).click(this.toggleMenu.bind(this));
	},

	reinit: function() {
		//$(/* class selector */).unbind();

		this.init();
	},

	toggleMenu: function(event) {

	}
})